import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import { isCurrentPath } from '@openclassrooms/routing';
import { getButtonLinkProps } from '@openclassrooms/routing';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import Button from '@classify/react-core-components/Button';
import useMainNavigation from '../../hooks/useMainNavigation';
import HeaderDropDown from './HeaderDropDown';
import HeaderDropDownGroup from './HeaderDropDown/HeaderDropDownGroup';
import HeaderDropDownOverTitle from './HeaderDropDown/HeaderDropDownOverTitle';
interface Props {
  name: string;
  onClick?: () => void;
}
const noop = () => {};
const BusinessDropDownMenu = t0 => {
  const $ = _c(53);
  const {
    name,
    onClick: t1
  } = t0;
  const onClick = t1 === undefined ? noop : t1;
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  const navigationConfig = useMainNavigation();
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = translate("main_header.business_products.dropdown.title");
    t3 = translate("main_header.business_products.dropdown.text");
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== navigationConfig.BUSINESS_DISCOVER.path) {
    t4 = getButtonLinkProps(navigationConfig.BUSINESS_DISCOVER.path);
    $[2] = navigationConfig.BUSINESS_DISCOVER.path;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== navigationConfig.BUSINESS_DISCOVER.content || $[5] !== navigationConfig.BUSINESS_DISCOVER.dataEvent || $[6] !== onClick || $[7] !== t4) {
    t5 = <HeaderDropDown.Title title={t2} subTitle={t3}><Button variant="secondary" {...t4} data-event={navigationConfig.BUSINESS_DISCOVER.dataEvent} onClick={onClick}>{navigationConfig.BUSINESS_DISCOVER.content}</Button></HeaderDropDown.Title>;
    $[4] = navigationConfig.BUSINESS_DISCOVER.content;
    $[5] = navigationConfig.BUSINESS_DISCOVER.dataEvent;
    $[6] = onClick;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <HeaderDropDownOverTitle title={{
      content: translate("business.main.header.upskill_reskill"),
      index: 0
    }} />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = navigationConfig.SPARK.path;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = translate("main_header.business_products.dropdown.spark.description");
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== navigationConfig.SPARK.path) {
    t9 = isCurrentPath(navigationConfig.SPARK.path);
    $[11] = navigationConfig.SPARK.path;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = navigationConfig.SPARK.dataEvent;
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = translate("main_header.business_products.dropdown.spark.title");
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== navigationConfig.SPARK.dataEvent || $[15] !== navigationConfig.SPARK.path || $[16] !== onClick || $[17] !== t9) {
    t12 = <HeaderDropDown.Item onClick={onClick} path={t7} subTitle={t8} isActive={t9} data-event={t10}>{t11}</HeaderDropDown.Item>;
    $[14] = navigationConfig.SPARK.dataEvent;
    $[15] = navigationConfig.SPARK.path;
    $[16] = onClick;
    $[17] = t9;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = navigationConfig.BOOST.path;
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = translate("main_header.business_products.dropdown.boos.description");
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== navigationConfig.BOOST.path) {
    t15 = isCurrentPath(navigationConfig.BOOST.path);
    $[20] = navigationConfig.BOOST.path;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  const t16 = navigationConfig.BOOST.dataEvent;
  let t17;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = translate("main_header.business_products.dropdown.boost.title");
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== navigationConfig.BOOST.dataEvent || $[24] !== navigationConfig.BOOST.path || $[25] !== onClick || $[26] !== t15) {
    t18 = <HeaderDropDown.Item onClick={onClick} path={t13} subTitle={t14} isActive={t15} data-event={t16}>{t17}</HeaderDropDown.Item>;
    $[23] = navigationConfig.BOOST.dataEvent;
    $[24] = navigationConfig.BOOST.path;
    $[25] = onClick;
    $[26] = t15;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  const t19 = navigationConfig.PIVOT.path;
  let t20;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = translate("main_header.business_products.dropdown.pivot.description");
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== navigationConfig.PIVOT.path) {
    t21 = isCurrentPath(navigationConfig.PIVOT.path);
    $[29] = navigationConfig.PIVOT.path;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  const t22 = navigationConfig.PIVOT.dataEvent;
  let t23;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = translate("main_header.business_products.dropdown.pivot.title");
    $[31] = t23;
  } else {
    t23 = $[31];
  }
  let t24;
  if ($[32] !== navigationConfig.PIVOT.dataEvent || $[33] !== navigationConfig.PIVOT.path || $[34] !== onClick || $[35] !== t21) {
    t24 = <HeaderDropDown.Item onClick={onClick} path={t19} subTitle={t20} isActive={t21} data-event={t22}>{t23}</HeaderDropDown.Item>;
    $[32] = navigationConfig.PIVOT.dataEvent;
    $[33] = navigationConfig.PIVOT.path;
    $[34] = onClick;
    $[35] = t21;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] !== t12 || $[38] !== t18 || $[39] !== t24) {
    t25 = <HeaderDropDownGroup>{t6}{t12}{t18}{t24}</HeaderDropDownGroup>;
    $[37] = t12;
    $[38] = t18;
    $[39] = t24;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] !== getLocalisationConfig || $[42] !== navigationConfig.FINALIZE_APPRENTICESHIP || $[43] !== navigationConfig.UPLIFT || $[44] !== onClick) {
    t26 = getLocalisationConfig("page.uplift.url") ? [<HeaderDropDownGroup><HeaderDropDownOverTitle title={{
        content: translate("main_header.business_products.dropdown.hire.tagline"),
        index: 1
      }} /><HeaderDropDown.Item onClick={onClick} path={navigationConfig.UPLIFT.path} subTitle={translate("main_header.business_products.dropdown.uplift.description")} isActive={isCurrentPath(navigationConfig.UPLIFT.path)} data-event={navigationConfig.UPLIFT.dataEvent}>{translate("main_header.business_products.dropdown.uplift.title")}</HeaderDropDown.Item>{getLocalisationConfig("apprenticeship.hasTalentPool") && <HeaderDropDown.Item onClick={onClick} path={navigationConfig.FINALIZE_APPRENTICESHIP.path} subTitle={translate("main_header.apprenticeship_dropdown.business_finalize.text")} isActive={isCurrentPath(navigationConfig.FINALIZE_APPRENTICESHIP.path)} data-event={navigationConfig.FINALIZE_APPRENTICESHIP.dataEvent}>{translate("main_header.apprenticeship_dropdown.business_finalize.title")}</HeaderDropDown.Item>}</HeaderDropDownGroup>] : [];
    $[41] = getLocalisationConfig;
    $[42] = navigationConfig.FINALIZE_APPRENTICESHIP;
    $[43] = navigationConfig.UPLIFT;
    $[44] = onClick;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== t25 || $[47] !== t26) {
    t27 = [t25, ...t26];
    $[46] = t25;
    $[47] = t26;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== name || $[50] !== t27 || $[51] !== t5) {
    t28 = <HeaderDropDown name={name} title={t5} items={t27} />;
    $[49] = name;
    $[50] = t27;
    $[51] = t5;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  return t28;
};
export default BusinessDropDownMenu;